module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "v-table-loading",
    style: ({
      'opacity': _vm.loadingOpacity
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "v-table-loading-content",
    domProps: {
      "innerHTML": _vm._s(_vm.loadingContent)
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6667aab7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-easytable/libs/v-table/src/loading.vue
// module id = 702
// module chunks = 85